import React from "react";
import CallinStatusPill from "../../../Pills/CallinStatusPill/CallinStatusPill";

export default function CallinStatusCell(cell) {
  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <CallinStatusPill value={cell.value} />
    </span>
  );
}